<template>
    <footer class="footer mt-auto py-3 bg-dark" data-bs-theme="dark">
        <div class="container d-flex flex-wrap justify-content-center align-items-center gap-3">
            <span class="text-secondary small">&copy; {{ new Date().getFullYear() }} Hägele GmbH</span>
            <nav class="d-flex gap-3">
                <router-link class="footer-link small" to="/imprint">{{ t('Imprint') }}</router-link>
                <router-link class="footer-link small" to="/privacy-policy">{{ t('Privacy policy') }}</router-link>
            </nav>
        </div>
    </footer>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";

.footer-link {
    color: var(--bs-secondary-color);
    text-decoration: none;

    &:hover {
        color: $primary;
    }
}
</style>
